/**
 * Null PEM Provider - no-op implementation
 */
export class NullPemProvider {
    initialisiere() { return true; }
    protokollKopf() { return true; }
    protokollZeile() { return true; }
    sgzKopfzeile() { return true; }
    trennLinie() { return true; }
    endLinie() { return true; }
    loescheTabZeilenPuffer() { return true; }
    uebertrageTabZeilenPuffer() { return true; }
    protokollAusgabe() { return true; }
    druckeEtikett() { return true; }
    printFormular() { return true; }
    printerFf() { return true; }
    freeMem() { return true; }
    loadFormular() { return true; }
    defaultDruckfeld() { return true; }
    defaultBesetzen() { return true; }
    forgetFormular() { return true; }
    writeDruckfeld() { return true; }
}
//# sourceMappingURL=pem.js.map